// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBqeUsJz_eDlo5eCqbhQyRIYXxfEO1ryAU",
  authDomain: "asraf-bike-service.firebaseapp.com",
  projectId: "asraf-bike-service",
  storageBucket: "asraf-bike-service.appspot.com",
  messagingSenderId: "654801821153",
  appId: "1:654801821153:web:4a12c6320184430a7286a0"
};

  export default firebaseConfig;